import * as React from 'react';

export default props => {
    return (
        <div className="footer-copyright">
            <span>&copy; {props.siteName}, {(new Date().getFullYear())}</span>
        </div>
    );
};